import { useMemo, useState } from 'react'
import api from '../Api'
import { makeQueryParams } from './shared'

const SubscriptionParams = {
  subscriptionId: 'subscriptionId=',
}
export const getSubscription = props => {
  const { subscriptionId } = props
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const getSubscriptionCall = async () => {
    setLoading(true)
    setError(false)

    const params = makeQueryParams(props, SubscriptionParams)
    if (!params) {
      setLoading(false)
      return
    }
    try {
      const res = await api.get(`/subscription?${params}`)
      if (res.status !== 204 && res.data) {
        setData(res.data)
      }
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    getSubscriptionCall()
  }, [subscriptionId])

  return { data, loading, error }
}



// WEBPACK FOOTER //
// ./src/lib/apiHooks/SubscriptionApi.js